<template>
  <div class="cabinet-login-view">
    <LoginHeaderForex v-if="region === 'forex'"></LoginHeaderForex>
    <LoginHeaderUk v-else-if="region === 'uk'"></LoginHeaderUk>
    <LoginHeaderLatam v-else-if="region === 'latam'"></LoginHeaderLatam>
    <LoginHeader v-else></LoginHeader>
    <div class="body margin-general">
      <div class="instructions">
        <h1>{{ $t("loginPage.instructionstitle") }}</h1>
        <p>{{ $t("loginPage.instructionsLine1") }}</p>
        <p>{{ $t("loginPage.instructionsLine2") }}</p>
        <ul>
          <li>{{ $t("loginPage.featureList1") }}</li>
          <li>{{ $t("loginPage.featureList2") }}</li>
          <li>{{ $t("loginPage.featureList3") }}</li>
          <li>{{ $t("loginPage.featureList4") }}</li>
          <li>{{ $t("loginPage.featureList5") }}</li>
        </ul>
      </div>
      <LoginBox
        ref="loginBox"
        :auto="true"
        v-on:submit="doSignIn"
        v-on:forgot="forgot"
      ></LoginBox>
    </div>

    <div class="footer" v-if="region == 'forex'">
      <FooterForex></FooterForex>
    </div>
    <div class="footer" v-else-if="region == 'uk'">
      <FooterUK></FooterUK>
    </div>
    <div class="footer" v-else-if="region == 'latam'">
      <FooterLatam></FooterLatam>
    </div>
    <div class="footer" v-else-if="region == 'mena'">
      <FooterMena></FooterMena>
    </div>
    <div class="footer" v-else>
      <FooterForex></FooterForex>
    </div>

    <Modal
      v-if="showDialog"
      @close="showDialog = false"
      dialogStyle="login-modal"
    >
      <template #header>
        <h3>{{ $t("register.login") }}</h3>
      </template>
      <template #body>
        <p>{{ dialogMessage }}</p>
      </template>
      <template #footer>
        <button @click="showDialogOKClicked">{{ $t("register.ok") }}</button>
      </template>
    </Modal>

    <Modal
      class="forgot-dialog"
      v-if="showForgotDialog"
      dialogStyle="login-modal"
    >
      <template v-slot:header>
        <h3>{{ $t("register.login") }}</h3>
      </template>
      <template v-slot:body>
        <p class="closeX" @click="showForgotDialog = false">x</p>
        <div class="newPassStyle">
          <!-- <p>{{ dialogMessage }}</p> -->
          <h2>{{ $t("register.instructions") }}</h2>
          <p
            v-if="dialogErrorMesssage != null"
            style="color: red; margin-bottom: 15px"
          >
            {{ dialogErrorMesssage }}
          </p>
          <label for="forgot1">{{ $t("register.code") }}</label>
          <input id="forgot1" type="password" v-model="forgotCode" />
          <label for="forgot2">{{ $t("register.newPass") }}</label>
          <input id="forgot2" type="password" v-model="newPass1" />
          <label for="forgot3">{{ $t("register.repeatPass") }}</label>
          <input id="forgot3" type="password" v-model="newPass2" />
        </div>
      </template>
      <template v-slot:footer>
        <button @click="submitNewPassword" :disabled="disabledChange">
          {{ $t("register.changePass") }}
        </button>
      </template>
    </Modal>

    <Modal
      class="forgot-dialog"
      v-if="showCodeDialog"
      @close="showCodeDialog = false"
      dialogStyle="login-modal"
    >
      <template v-slot:header>
        <h3>{{ $t("register.login") }}</h3>
      </template>
      <template v-slot:body>
        <div>
          <p>{{ dialogMessage }}</p>
          <input type="password" v-model="newCode" maxlength="6" />
        </div>
      </template>
      <template v-slot:footer>
        <button class="" @click="submitRequestNewCode">{{ $t("register.sendCode") }}</button>
        <button @click="submitNewCode">{{ $t("register.submit") }}</button>
      </template>
    </Modal>
    <Modal
      class="forgot-dialog"
      v-if="showTOTPDialog"
      @close="showTOTPDialog = false"
      dialogStyle="login-modal"
    >
      <template v-slot:header>
        <h3>{{ $t("register.login") }}</h3>
      </template>
      <template v-slot:body>
        <div>
          <p>{{ dialogMessage }}</p>
          <p v-if="dialogErrorMessage" style="color: red">
            {{ dialogErrorMessage }}
          </p>
          <input type="number" v-model="totpCode" />
        </div>
      </template>
      <template v-slot:footer>
        <button @click="totpLogin">{{ $t("register.login") }}</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import LoginHeader from "@/components/login/LoginHeader";
import LoginHeaderForex from "@/components/login/forex/LoginHeaderForex.vue";
import LoginHeaderUk from "@/components/login/uk/LoginHeaderUk.vue";
import LoginHeaderLatam from "@/components/login/latam/LoginHeaderLatam.vue";
import LoginBox from "@/components/login/LoginBox";
import Modal from "@/components/Modal";
import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
} from "@vue/runtime-core";
import { i18n } from "@/plugins/i18n";
import store from "@/store";
import { useRoute, useRouter } from "vue-router";
import FooterForex from "../../components/cabinet/forex/FooterForex.vue";
import FooterMena from "../../components/cabinet/mena/FooterMena.vue";
import FooterUK from "../../components/cabinet/uk/FooterUK.vue";
import FooterLatam from "../../components/cabinet/latam/FooterLatam.vue";

export default {
  created() {
    document.title = "Login | " + process.env.VUE_APP_CABINET_V2_WEBSITE_NAME;
  },
  name: "Login",
  emits: ["onError"],

  components: {
    LoginHeader,
    LoginHeaderForex,
    LoginHeaderUk,
    LoginHeaderLatam,
    LoginBox,
    Modal,
    FooterUK,
    FooterMena,
    FooterForex,
    FooterLatam,
  },
  setup(props) {
    let dialogMessage = ref(null);
    let dialogErrorMessage = ref(null);
    let showDialog = ref(false);
    let showForgotDialog = ref(false);
    let showTOTPDialog = ref(false);
    let showCodeDialog = ref(false);
    let totpCode = ref(null);
    let forgotCode = ref(null);
    let newCode = ref(null);
    let newPass1 = ref(null);
    let newPass2 = ref(null);
    let user = ref(null);
    let authUser = ref(null);
    let forgotEmail = ref(null);
    let attemptedEmail = ref(null);
    let dialogErrorMesssage = ref(null);
    let disabledChange = ref(false);

    const region = ref(process.env.VUE_APP_CABINET_ORIGIN);

    const loginBox = ref(null);

    const router = useRouter();

    const route = useRoute();

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    onMounted(() => {
      store.commit("setLoginFlow", "LOGIN");

      emitter.on("showForgotDialog", (message) => {
        dialogMessage.value = message;
        showDialog.value = false;
        showCodeDialog.value = false;
        showForgotDialog.value = true;
      });

      emitter.on("showDialog", (message) => {
        dialogMessage.value = message;
        showCodeDialog.value = false;
        showDialog.value =
          message == "Cannot read properties of null (reading 'release')"
            ? false
            : true;
      });

      emitter.on("showTOTPDialog", (message) => {
        dialogMessage.value = message;
        dialogErrorMessage.value = null;
        showTOTPDialog.value = true;
      });

      emitter.on("showCodeDialogAtLogin", (message) => {
        dialogMessage.value = message;
        dialogErrorMessage.value = null;
        showCodeDialog.value = true;
      });

      emitter.on("showCodeDialogErrorMessageAtLogin", (message) => {
        dialogErrorMessage.value = message;
      });

      emitter.on("successfulRequest", () => {
        loginBox.value.release();
      });

      emitter.on("failedRequest", () => {
        if (loginBox && typeof loginBox.value !== "undefined")
          loginBox.value.release();
      });
      const htmlLang = document.querySelector('html').getAttribute('lang');
      console.log(htmlLang);
      if(htmlLang === "ar") {
          document.documentElement.setAttribute("dir", "rtl")
        } else {
          document.documentElement.setAttribute("dir", "ltr")
        }
    });

    onUnmounted(() => {
      emitter.off("showForgotDialog");
      emitter.off("showDialog");
      emitter.off("showTOTPDialog");
      emitter.off("showCodeDialogAtLogin");
      emitter.off("successfulRequest");
      emitter.off("failedRequest");
    });

    const forgot = (email) => {
      emitter.emit("requestForgotPassword", {
        email: email,
      });

      forgotEmail.value = email;
      loginBox.value.release();
    };

    const totpLogin = async () => {
      showTOTPDialog.value = false;
      loginBox.value.lock();

      emitter.emit("requestTOTPLogin", {
        totpCode: totpCode,
      });
    };

    const submitNewPassword = async () => {
      loginBox.value.lock();

      if (
        forgotEmail.value != null &&
        newPass1.value != null &&
        newPass2.value != null &&
        newPass1.value === newPass2.value
      ) {
        // disabledChange.value = false
        let passw = /^(?=.*?[a-z]).{6,}$/;
        let passw1 = /^(?=.*?[a-z])(?=.*?[0-9]).{6,}$/;
        let passw2 = /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/;

        if (newPass1.value.match(passw)) {
          if (newPass1.value.match(passw1)) {
            if (newPass1.value.match(passw2)) {
              if (newPass1.value === newPass2.value) {
                Auth.forgotPasswordSubmit(
                  forgotEmail.value,
                  forgotCode.value,
                  newPass1.value
                )
                  .then((user) => {
                    showForgotDialog.value = false;
                    emitter.emit("showDialog",i18n.global.t("loginPage.changeSuccess"));
                    forgotEmail.value = null;
                    newPass1.value = null;
                    newPass2.value = null;
                    loginBox.value.release();
                  })
                  .catch((e) => {
                    newPass1.value = null;
                    newPass2.value = null;
                    dialogErrorMesssage.value = e.message;
                    loginBox.value.release();
                  });
              } else {
                dialogErrorMesssage.value = i18n.global.t("loginPage.passNotMatch");
              }
            } else {
              dialogErrorMesssage.value =
              i18n.global.t("loginPage.passSpecialC");
            }
          } else {
            dialogErrorMesssage.value =
            i18n.global.t("loginPage.passNumber");
          }
        } else {
          dialogErrorMesssage.value =
          i18n.global.t("loginPage.passLength");
        }
      } else {
        dialogErrorMesssage.value = i18n.global.t("loginPage.reviewData");
      }
    };

    const submitNewCode = async () => {
      emitter.emit("requestConfirmSignUp", {
        email: attemptedEmail.value,
        newCode: newCode.value,
      });
    };

    const submitRequestNewCode = () => {
      // showCodeDialog.value = false
      newCode.value = null;
      dialogErrorMessage.value = null;
      emitter.emit("requestNewCode", {
        email: attemptedEmail.value,
      });
    };

    const doSignIn = (email, password) => {
      showDialog.value = false;
      attemptedEmail.value = email;
      if (
        email != null &&
        password != null &&
        email.length > 0 &&
        password.length > 0
      ) {
        emitter.emit("requestSignIn", {
          email: email,
          password: password,
        });
      } else {
        console.log("email/password form validation error");
        // dialogMessage.value = "Please enter a valid email/password"
        // showDialog.value = true
        // loginBox.value.release()
        emitter.emit("showDialog", i18n.global.t("loginPage.valid"));
        loginBox.value.release();
      }
    };

    let googleSignInURL = ref(
      "https://" +
        process.env.VUE_APP_CABINET_V2_COGNITO_DOMAIN_HOST +
        "/login?response_type=token&client_id=" +
        process.env.VUE_APP_CABINET_V2_GOOGLE_FEDERATED_LOGIN_CLIENT_ID +
        "&redirect_uri=" +
        process.env.VUE_APP_CABINET_V2_GOOGLE_FEDERATED_LOGIN_REDIRECT_URI
    );

    const showDialogOKClicked = () => {
      showDialog.value = false;
      console.log(store.state.dialogOKAction);
      if (store.state.dialogOKAction) {
        let dialogOKAction = store.state.dialogOKAction;
        store.commit("setDialogOKAction", null);
        switch (dialogOKAction.action) {
          case "ROUTE":
            router.replace("/register/2/live-account").catch((error) => {
              console.error(error);
            });
            break;
          default:
            console.error("unknown dialog ok action: " + dialogOKAction.action);
        }
      }
      store.commit("setDialogOKAction", null);
    };

    return {
      googleSignInURL,
      loginBox,
      forgot,
      totpLogin,
      submitNewPassword,
      submitNewCode,
      submitRequestNewCode,
      doSignIn,
      showDialogOKClicked,
      dialogMessage,
      dialogErrorMessage,
      showDialog,
      showForgotDialog,
      showTOTPDialog,
      showCodeDialog,
      totpCode,
      forgotCode,
      newCode,
      newPass1,
      newPass2,
      user,
      authUser,
      forgotEmail,
      attemptedEmail,
      dialogErrorMesssage,
      disabledChange,
      region,
    };
  },
};
</script>